export default "__VITE_ASSET__d1160cc6__"